import React, { useState } from 'react'
import './SponsorItem.css'
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { config } from '../../../../../config';
import WarningDialogue from '../../../../../Util/WarningDialogue';
import axiosApi from '../../../../../core/interceptor/interceptor';

export default function SponsorItem(props) {
  const [popupContent, setPopupContent] = useState({});
  const [openWarningPopup, setOpenWarningPopup] = useState(false);

  const deleteItem = (props) => {
    setOpenWarningPopup(true);
    setPopupContent({
      header: 'Delete?',
      description: `Are you sure you want to delete this?`,
      icon: faExclamationCircle,
      action: () => {
        axiosApi.delete(`${config.apiUrl}/sponsor/${props?.itemDetails?.id}`)
          .then(() => {
            setOpenWarningPopup(false);
            props.isItemDelete(true);
          }).catch(() => {
            setOpenWarningPopup(false);
          })
      }
    })
  }

  return <>
    <div className='adminMenuItemContainer'>
      
      <span className="close" onMouseDown={() => deleteItem(props)}>
        &times;
      </span>
      <div className="disabled-blk" onMouseDown={() => props.setItemDisplay()}>
        {props.itemDetails.image !== '' && props.itemDetails.image !== null ?
          <img className='adminMenuItemImage' src={`${config.cdnUrl}/sponsors/${props.itemDetails.image}`} alt={props.itemDetails.image} />
          :
          <div className='adminMenuMissingItemContainer'>
            {props.itemDetails.available && !props.itemDetails.hidden && <p className='adminMenuMissingItemText'>No Image</p>}
          </div>
        }
      </div>
      <div className="content-blk">
        <div className="title-blk">
          <div className="left">
            <h2 title={props?.itemDetails?.name} className='adminMenuItemTitle'>{props?.itemDetails?.name}</h2>
          </div>
        </div>
        <p className='adminMenuItemDescription'></p>
      </div>
    </div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => {setOpenWarningPopup(false); props.isItemDelete(false, '');}}
    />
  </>
}